export const PageBg = () => {
  return (
    <svg
      className='absolute top-0 left-0 -z-10 h-full w-full object-cover'
      preserveAspectRatio='xMidYMid slice'
      width='2127'
      height='677'
      viewBox='0 0 2127 677'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.1' filter='url(#filter0_f_19_12957)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M1654.18 154.417C1647.83 152.809 1641.35 156.597 1639.65 162.944L1640.38 160.197C1638.18 168.108 1630 172.784 1622.05 170.654L1526.6 145.076C1520.19 143.361 1516.39 136.781 1518.11 130.379L1521.22 118.789L1083.27 1.44273L1143.06 -221.686C1144.49 -227.021 1149.97 -230.187 1155.31 -228.757L1961.26 -12.8022C1966.6 -11.3727 1969.76 -5.88938 1968.33 -0.554724L1911.14 212.915C1909.71 218.25 1904.22 221.415 1898.89 219.986L1654.18 154.417Z'
          fill='url(#paint0_linear_19_12957)'
        />
      </g>
      <g opacity='0.1' filter='url(#filter1_f_19_12957)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M1654.18 154.417C1647.83 152.809 1641.35 156.597 1639.65 162.944L1640.38 160.197C1638.18 168.108 1630 172.784 1622.05 170.654L1526.6 145.076C1520.19 143.361 1516.39 136.781 1518.11 130.379L1521.22 118.789L1083.27 1.44273L1143.06 -221.686C1144.49 -227.021 1149.97 -230.187 1155.31 -228.757L1961.26 -12.8022C1966.6 -11.3727 1969.76 -5.88938 1968.33 -0.554724L1911.14 212.915C1909.71 218.25 1904.22 221.415 1898.89 219.986L1654.18 154.417Z'
          fill='url(#paint1_linear_19_12957)'
        />
      </g>
      <g clip-path='url(#clip0_19_12957)'>
        <g clip-path='url(#clip1_19_12957)'>
          <rect
            width='867.365'
            height='675.805'
            transform='translate(0 30.1943)'
            fill='url(#paint2_linear_19_12957)'
          />
          <g filter='url(#filter2_d_19_12957)'>
            <path
              d='M526.685 211.706L525.618 1149.85L368.849 1037.23V406.666V406.135L368.315 405.604L278.199 341.325L275.533 339.2V342.388L275 1084.51V1085.04L276.066 1085.57L616.267 1329.41L618.934 1331V1327.81L620 164.427V163.896L619.467 163.364L278.733 -78.875L276.066 -81V-77.8125V32.6827V33.7451L276.6 34.2764L366.716 97.4922V96.9611L526.685 211.706Z'
              fill='url(#paint3_linear_19_12957)'
            />
            <path
              d='M103.685 1273.29L102.618 335.148L-54.1514 447.768L-54.1514 1078.33V1078.87L-54.6847 1079.4L-144.801 1143.67L-147.467 1145.8V1142.61L-148 400.489V399.958L-146.934 399.427L193.267 155.594L195.934 154V157.187L197 1320.57V1321.1L196.467 1321.64L-144.267 1563.88L-146.934 1566V1562.81V1452.32V1451.25L-146.4 1450.72L-56.2843 1387.51V1388.04L103.685 1273.29Z'
              fill='url(#paint4_linear_19_12957)'
            />
          </g>
        </g>
        <g clip-path='url(#clip2_19_12957)'>
          <g filter='url(#filter3_d_19_12957)'>
            <path
              d='M1854.68 282.706L1853.62 1220.85L1696.85 1108.23V477.666V477.135L1696.32 476.604L1606.2 412.325L1603.53 410.2V413.388L1603 1155.51V1156.04L1604.07 1156.57L1944.27 1400.41L1946.93 1402V1398.81L1948 235.427V234.896L1947.47 234.364L1606.73 -7.875L1604.07 -10V-6.8125V103.683V104.745L1604.6 105.276L1694.72 168.492V167.961L1854.68 282.706Z'
              fill='url(#paint5_linear_19_12957)'
            />
            <path
              d='M1333.56 166.414L1333.04 622.863L1256.7 568.069V261.271V261.012L1256.44 260.754L1212.56 229.48L1211.26 228.446V229.997L1211 591.072V591.331L1211.52 591.589L1377.18 710.225L1378.48 711V709.449L1379 143.411V143.152L1378.74 142.894L1212.82 25.0339L1211.52 24V25.5508V79.3116V79.8286L1211.78 80.087L1255.66 110.844V110.586L1333.56 166.414Z'
              fill='url(#paint6_linear_19_12957)'
              fill-opacity='0.8'
            />
            <path
              d='M1409.56 132.414L1409.04 588.863L1332.7 534.069V227.271V227.012L1332.44 226.754L1288.56 195.48L1287.26 194.446V195.997L1287 557.072V557.331L1287.52 557.589L1453.18 676.225L1454.48 677V675.449L1455 109.411V109.152L1454.74 108.894L1288.82 -8.96606L1287.52 -10V-8.44916V45.3116V45.8286L1287.78 46.087L1331.66 76.8443V76.5859L1409.56 132.414Z'
              fill='url(#paint7_linear_19_12957)'
              fill-opacity='0.8'
            />
            <path
              d='M1563.68 1284.29L1562.62 346.148L1405.85 458.768V1089.33V1089.87L1405.32 1090.4L1315.2 1154.67L1312.53 1156.8V1153.61L1312 411.489V410.958L1313.07 410.427L1653.27 166.594L1655.93 165V168.187L1657 1331.57V1332.1L1656.47 1332.64L1315.73 1574.88L1313.07 1577V1573.81V1463.32V1462.25L1313.6 1461.72L1403.72 1398.51V1399.04L1563.68 1284.29Z'
              fill='url(#paint8_linear_19_12957)'
            />
          </g>
        </g>
        <rect
          width='2127'
          height='170'
          transform='matrix(1 0 0 -1 0 677)'
          fill='url(#paint9_linear_19_12957)'
        />
        <g filter='url(#filter4_f_19_12957)'>
          <ellipse cx='1860' cy='738' rx='536' ry='82' fill='#7F84F7' fill-opacity='0.07' />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_f_19_12957'
          x='829.273'
          y='-483.101'
          width='1393.4'
          height='957.43'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='127' result='effect1_foregroundBlur_19_12957' />
        </filter>
        <filter
          id='filter1_f_19_12957'
          x='829.273'
          y='-483.101'
          width='1393.4'
          height='957.43'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='127' result='effect1_foregroundBlur_19_12957' />
        </filter>
        <filter
          id='filter2_d_19_12957'
          x='-203'
          y='-111'
          width='878'
          height='1757'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='25' />
          <feGaussianBlur stdDeviation='27.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 0.482039 0 0 0 0 0.00392157 0 0 0 0.04 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19_12957'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_19_12957'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_19_12957'
          x='1156'
          y='-40'
          width='847'
          height='1697'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='25' />
          <feGaussianBlur stdDeviation='27.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 0.482039 0 0 0 0 0.00392157 0 0 0 0.04 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19_12957'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_19_12957'
            result='shape'
          />
        </filter>
        <filter
          id='filter4_f_19_12957'
          x='1150'
          y='482'
          width='1420'
          height='512'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='87' result='effect1_foregroundBlur_19_12957' />
        </filter>
        <linearGradient
          id='paint0_linear_19_12957'
          x1='1343.75'
          y1='166.481'
          x2='1967.11'
          y2='-22.782'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.0001' stop-color='#FFC107' />
          <stop offset='1' stop-color='#FF9737' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_19_12957'
          x1='1343.75'
          y1='166.481'
          x2='1967.11'
          y2='-22.782'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.0001' stop-color='#FFC107' />
          <stop offset='1' stop-color='#FF9737' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_19_12957'
          x1='433.682'
          y1='0'
          x2='433.682'
          y2='675.805'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_19_12957'
          x1='447.5'
          y1='1331'
          x2='-292.343'
          y2='421.944'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_19_12957'
          x1='24.5'
          y1='154'
          x2='-715.343'
          y2='1063.06'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_19_12957'
          x1='1775.5'
          y1='1402'
          x2='1035.66'
          y2='492.944'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_19_12957'
          x1='1295'
          y1='711'
          x2='935.096'
          y2='268.405'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_19_12957'
          x1='1371'
          y1='677'
          x2='1011.1'
          y2='234.405'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_19_12957'
          x1='1484.5'
          y1='165'
          x2='744.657'
          y2='1074.06'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_19_12957'
          x1='1063.5'
          y1='0'
          x2='1063.5'
          y2='170'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0' />
        </linearGradient>
        <clipPath id='clip0_19_12957'>
          <rect width='2127' height='676' fill='white' transform='translate(0 1)' />
        </clipPath>
        <clipPath id='clip1_19_12957'>
          <rect
            width='867.365'
            height='675.805'
            fill='white'
            transform='translate(0 30.1943)'
          />
        </clipPath>
        <clipPath id='clip2_19_12957'>
          <rect width='817' height='703.84' fill='white' transform='translate(1188 1)' />
        </clipPath>
      </defs>
    </svg>
  );
};
